
<template lang="html">
  <div id="vue-gf-frp-search">
    <div class="">
      <div class="header-container-mobile">
        <div class="col-12">

          <div class="mb-3">
            <div class="offset-md-3 col-md-6">
              <div class="input-group align-items-center input-group-search bg-white">
                <div class="input-group-prepend"> 
                  <div class="p-2"><i class="fa fa-search fa-fw text-muted"></i> </div>
                </div>
                <input
                  v-model="searchString"
                  type="text"
                  class="form-control search-input"
                  :placeholder="searchPlaceholder"
                  aria-label="Search"
                  aria-describedby="basic-addon2"
                  @keyup.enter="getFundraiserSearchResults"
                >
                <div class="input-group-append event-theme-body-text-font-family">
                  <select
                    v-if="settings.showPageTypeFilter"
                    id="pageType"
                    class="custom-select"
                    v-model="selectedPageType"
                    @change="pageTypeChange"
                  >
                    <option
                      v-for="pageType in pageTypes"
                      :key="pageType.value"
                      :value="pageType.value"
                    >
                      {{ pageType.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <component
        :is="componentToLoad"
        :fundraiser-search-results="fundraiserSearchResults"
        :loading="loading"
        :hide-join-team="settings.pageId > 0 && settings.includeTeamMembers"
        @loadMore="performSearchAndUpdateResults"
        :design="settings.design"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import "promise-polyfill/src/polyfill";
import Base from './Base.vue';
import lookups from '../common/lookups'
import constants from '../common/constants';
import gfComponents from "./components";
import Loader from "vue-spinner/src/ClipLoader.vue";
import fundraiserSearchData from '../data/fundraiserSearchData.json'

export default {
  name: "FundraiserSearch",
  components: {Loader },
  mixins: [Base],
  props: {
    title: {
      type: String,
      default: 'Search Fundraisers',
    },
    searchPlaceholder: {
      type: String,
      default: 'Find a fundraiser or team to support',
    },
    blockBackgroundColor: {
      type: String,
      default: "",
    },
    blockTextColor: {
      type: String,
      default: "",
    },
    settings: {
      type: Object,
      default: () => {
        return {
          showPageTypeFilter : false,
          pageId: 0,
          includeTeamMembers : false ,
          mode: { name: constants.FUNDRAISER_SEARCH_DEFAULT_MODE },
          searchInputInterval: 200,
          design: '',
        }
      },
    },
    isDemoMode: {
      type: Boolean,
      default: false,
    },
  },

  data: function() {
    return {
      searchString: "",
      fundraiserSearchResults: [],
      driverButtonColour: "",
      driverTextColour: "",
      loading: false,
      morePages: true,
      currentPage: 1,
      pageTypes: [],
      selectedPageType: "",
      componentMode: '',
      requestController: false,
      inputIntervalInstance: null,
    };
  },
  computed: {
    componentToLoad() {
      if (!this.componentMode || this.componentMode == '')
          return null;

      return gfComponents.LoadComponent(this.componentMode);
    }
  },

  watch: {
    searchString() {
      if (this.inputIntervalInstance) {
        clearTimeout(this.inputIntervalInstance)
      }

      this.inputIntervalInstance = setTimeout(() => {
        this.getFundraiserSearchResults()
      }, _.get(this.settings, 'searchInputInterval', 200))
    }
  },

  created() {
    if(this.settings && this.settings.mode) {
      this.componentMode = this.settings.mode.name;
    }else{
      this.componentMode = constants.FUNDRAISER_SEARCH_DEFAULT_MODE;
    }
  },

  mounted: function() {
    this.getPageTypes()
    this.getFundraiserSearchResults()
    this.driverButtonColour = this.blockBackgroundColor
    this.driverTextColour = this.blockTextColor
  },

  methods: {
    getPageTypes() {
      this.pageTypes = lookups.PAGE_TYPES;
      this.selectedPageType = this.pageType;
    },
    pageTypeChange(){
      this.getFundraiserSearchResults();
    },
    getFundraiserSearchResults() {
      this.morePages = true;
      this.currentPage = 1;

      const debounce = _.debounce(async () => {
        this.fundraiserSearchResults = [];
        await this.performSearchAndUpdateResults();
      }, 500)
      
      debounce();
    },

    async performSearchAndUpdateResults() {
      if (!this.morePages)
          return;

      this.loading = true;
      var results = await this.populateFundraisers(this.currentPage);
      
      if (results.Pages) {
        results.Pages.forEach((o) => {
          this.fundraiserSearchResults.push(o);
        });

        this.fundraiserSearchResults.concat(
          results.Pages
        );
      }

      this.loading= false;
      this.morePages = this.isMoreDataAvailable(results);
      this.currentPage += 1;
    },

    isMoreDataAvailable(response) {
      return (
        response.ResultsReturned == this.size &&
        response.PageNumber <= response.TotalPages
      );
    },

    async populateFundraisers(pageIndex) {
      var vm = this;
      var url = `https://${this.apiDomain}/v1/pages/search?query=${encodeURIComponent(this.searchString)}&region=${this.regionCode}&eventcampaignid=${this.eventId}&beneficiaryaccountid=${this.beneficiaryId}&excludepageswithnofundraising=true&pagesize=${this.size}&pageindex=${pageIndex}&tags=${this.tags}`;
      // do not filter by the pageType if include member is true
      var isIncludeMember = this.settings.includeTeamMembers && this.settings.pageId;
      if(vm.selectedPageType !== "" && !isIncludeMember)
          url +=`&pagetype=${this.selectedPageType}`;

      if(this.settings.pageId)
          url +=`&pageid=${this.settings.pageId}`;

      if (typeof this.settings.includeTeamMembers != 'undefined' && this.settings.includeTeamMembers !== null)
          url +=`&includeteammembers=${this.settings.includeTeamMembers}`;
        
      url+=`&sortby=${this.selectedPageType.toLowerCase() == constants.FUNDRAISING_PAGE_TEAM_TYPE_ID.toLowerCase()
        ? constants.FUNDRAISING_PAGE_LEADERBOARD_SORT_BY_TEAM_TOTAL 
        : constants.FUNDRAISING_PAGE_LEADERBOARD_SORT_BY_TOTAL}`;

      return await this.getFundraiserData(url);
    },

    async getFundraiserData(url) {
      const controller = new AbortController();
      
      if (this.requestController) {
        this.requestController.abort()
      }

      this.requestController = controller
      var res = (this.isDemoMode) 
          ? await new Promise(resolve => resolve(fundraiserSearchData))
          : await axios.get(url, { signal : controller.signal });

      return this.constructFundraiser(res.data) ;
    },

    constructFundraiser(data){
      var items = [];
      data.Pages.forEach(element => {
        var total =  element.PageType == constants.FUNDRAISING_PAGE_TEAM_TYPE_ID ? element.Team.TeamTotal : element.Total;
        items.push({
          id: element.Id,
          name: `${element.CreatorName}`,
          donateUrl: element.DonationUrl,
          joinTeamUrl: element.Team ? element.Team.JoinTeamUrl : null,
          raised: parseInt(total).toFixed(2),
          pageUrl: element.Url,
          imageUrl: element.ImagePath,
          eventImageUrl: element.Event.EventImagePath,
          eventName: element.Event.EventName,
          title: element.PageTitle,
          secondaryBgColor: element.Event.EventTheme.SecondaryButtonFontColour,
          eventHomeUrl: element.Event.EventUrl,
          pageType : element.PageType,
        });
      });

      return {
        Pages: items,
        ResultsReturned: data.ResultsReturned,
        TotalPages: data.TotalPages,
        PageNumber: data.PageNumber,
      };

    }
  }
};
</script>

<style lang="css" scoped>

#vue-gf-frp-search {
  margin-top: -30px;
  font-family: Montserrat;
}

.header-container-mobile > div > div.input-group{
    padding: 25px 0;
    margin-bottom: 0px !important;
}

.gf-frp-search-button .btn-success {
    border: 0;
    padding: 11px 25px;
}

.input-group>.custom-select:not(:last-child), #vue-gf-frp-search .input-group>.form-control:not(:last-child) {
    font-size: 14px;
    color: #000;
}

.form-control{
    border-color: #ccc;
}

.input-group-search {
  border: 0px;
  padding: 10px;
  border-radius: 8px;
  -webkit-box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.06);
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.06);
  z-index: 9;
  flex-wrap: nowrap;
}

.input-group-search .input-group-prepend {
  width: auto !important;
}

.search-input {
  border: 0px;
  border-right: 1px solid #eee;
}

.search-input:focus {
  outline: -webkit-focus-ring-color auto 0px !important;
  box-shadow: none;
  border-color: #eee !important;
}

.form-control::placeholder {
    color: #c7c7c7;
}

.container > .row{
    width:100%;
    margin-left: 0;
    margin-right: 0;
}

.pointer {
    cursor: pointer;
}

select#pageType {
    border: 0;
    margin-left: 0.5rem;
    padding-left: 10px;
    font-size: 14px;
    border-radius: .25rem;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 1rem;
}

select#pageType:focus-visible {
  outline: -webkit-focus-ring-color auto 0px;
}

@media (max-width: 640px){
    .input-group > * {
        width: auto !important;
        margin-left: 0 !important;
    }

    select#pageType{
        height: 38px;
    }

    .input-group-append .btn {
        margin-left: 0 !important;
        margin-top: 15px;
        width: 100%;
    }
}

</style>
